/**
 * @file 應用程式根元件
 * @description React 應用程式根元件，包含路由與全域狀態
 */
import { useEffect, ReactNode } from 'react';
import {
  RouterProvider,
  useLocation,
  useNavigationType
} from 'react-router-dom';
import { useSelector } from 'react-redux';
import ReactGA from 'react-ga4';

import router from './routes/router';
import { RootState } from './store/store';

import Loading from 'components/loading/Loading';

/**
 * Google Analytics 追蹤元件
 */
function GaTracker(): null {
  const location = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    ReactGA.send({
      hitType: 'pageview',
      page: location.pathname + location.search
    });
  }, [location, navigationType]);

  return null;
}

/**
 * 應用程式根元件
 */
function App(): ReactNode {
  const isFetchLoading = useSelector((state: RootState) => state.loading);

  useEffect(() => {
    // 延遲初始化 Google Analytics，避免阻塞首次渲染
    const init = () => ReactGA.initialize('G-6ZWSTSVNRP');
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(init);
    } else {
      setTimeout(init, 0);
    }
  }, []);

  return (
    <>
      <Loading isLoading={isFetchLoading} />
      <RouterProvider router={router}>
        <GaTracker />
      </RouterProvider>
    </>
  );
}

export default App;
